import { Box, Typography, Avatar } from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import InstitutionsImage from '../icons/InstitutionsImage';
import IconTeacher from '../icons/IconTeacher';

// const rankingmoks = {
//   ranking1: {
//     img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0RGtxnp6kscDWkHUCHoUTodsIx0-McMzKNA&s',
//     number: 10,
//     name: 'Ensino Fndamental II',
//   },
//   ranking2: {
//   },
//   ranking3: {
//   },
// };
const RankingComponent = ({ isInstitute = false, data}) => {
  const isValidData = (index) => {
    return (
      data &&
      data[index] &&
      data[index].img !== undefined &&
      data[index].name !== undefined &&
      data[index].number !== undefined
    );
  };

  const hasFirstPlace = isValidData('ranking1');
  const hasSecondPlace = isValidData('ranking2');
  const hasThirdPlace = isValidData('ranking3');

  return (
    <Box mt={15} sx={{ display: 'flex', height: '400px', boxSizing: 'border-box', marginTop: '80px' }}>

{     hasFirstPlace && <Box display={'flex'} flexDirection={'column'} alignItems={'center'} height={'400px'} justifyContent={'end'}>
        
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mb={2}>
          {isInstitute ? (
            <Box sx={{ borderRadius: '50%', padding: '15px 13px' }}>
              <IconTeacher sx={{ fontSize: '100px', marginTop: '-13px' }} fill='#6F509680' />
            </Box>
          ) : (
            <Avatar
              variant={'circular'}
              sx={{
                width: 86,
                height: 86,
                backgroundColor: 'transparent',
                boxShadow: 5,
              }}
              src={data.ranking1.img}
            ></Avatar>
          )}
          <Typography fontSize={14} fontWeight={'bold'}>
            {data.ranking2.number}
          </Typography>
        </Box>
        
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          mt={0}
          sx={{
            minWidth: '149px',
            minHeight: '250px',
            backgroundColor: '#6F509680',
            borderRadius: '10px 0px 0px 10px',
            justifyContent: 'space-between',
            paddingBottom: '30px',
          }}
        >
          <Typography mt={2} color={'#FFF'} fontSize={14} fontWeight={'bold'}>
            {data.ranking2.name}
          </Typography>
          <WorkspacePremiumIcon sx={{ marginTop: '20px', color: '#FFF', width: 80, height: 80 }} />
        </Box>
      </Box>}


{     hasSecondPlace && <Box display={'flex'} flexDirection={'column'} alignItems={'center'} height={'400px'} justifyContent={'end'}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mb={2}>
          {isInstitute ? (
            <Box sx={{ borderRadius: '50%', padding: '15px 13px' }}>
              <IconTeacher sx={{ fontSize: '100px', marginTop: '-13px' }} fill='#FDC500' />
            </Box>
          ) : (
            <Avatar
              variant={'circular'}
              sx={{
                width: 86,
                height: 86,
                backgroundColor: 'transparent',
                boxShadow: 5,
              }}
              src={data.ranking1.img}
            ></Avatar>
          )}
          <Typography fontSize={14} fontWeight={'bold'}>
            {data.ranking1.number}
          </Typography>
          
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          mt={0}
          sx={{
            minWidth: '149px',
            minHeight: '300px',
            backgroundColor: '#FDC500',
            borderRadius: '10px 10px 0px 0px',
            justifyContent: 'space-between',
            paddingBottom: '50px',
          }}
        >
          <Typography mt={2} color={'#FFF'} fontSize={14} fontWeight={'bold'}>
            {data.ranking1.name}
          </Typography>
          <EmojiEventsIcon sx={{ marginTop: '20px', color: '#FFF', width: 80, height: 80 }} />
        </Box>
      </Box>}

{     hasThirdPlace && <Box display={'flex'} flexDirection={'column'} alignItems={'center'} height={'400px'} justifyContent={'end'}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mb={2}>
          {isInstitute ? (
            <Box sx={{ borderRadius: '50%', padding: '15px 13px' }}>
              <IconTeacher sx={{ fontSize: '100px', marginTop: '-13px' }} fill='#6F509680'/>
            </Box>
          ) : (
            <Avatar
              variant={'circular'}
              sx={{
                width: 86,
                height: 86,
                backgroundColor: 'transparent',
                boxShadow: 5,
              }}
              src={data.ranking1.img}
            ></Avatar>
          )}
          <Typography fontSize={14} fontWeight={'bold'}>
            {data.ranking3.number}
          </Typography>
         
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          mt={0}
          sx={{
            minWidth: '149px',
            minHeight: '200px',
            backgroundColor: '#6F509680',
            borderRadius: '0px 10px 10px 0px',
            justifyContent: 'space-between',
            paddingBottom: '30px',
          }}
        >
          <Typography mt={2} color={'#FFF'} fontSize={14} fontWeight={'bold'}>
            {data.ranking3.name}
          </Typography>
          <WorkspacePremiumIcon sx={{ marginTop: '20px', color: '#FFF', width: 80, height: 80 }} />
        </Box>
      </Box>}
    </Box>
  );
};

export default RankingComponent;
